var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "company") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "apartment_FILL1_wght400_GRAD0_opsz20",
    d: "M144,256V243.429h3.429V240H156v6.857h4V256h-6.857v-3.429h-2.286V256Zm1.714-1.714h1.714v-1.714h-1.714Zm0-3.714h1.714v-1.714h-1.714Zm0-3.714h1.714v-1.714h-1.714Zm3.429,3.714h1.714v-1.714h-1.714Zm0-3.714h1.714v-1.714h-1.714Zm0-3.429h1.714v-1.714h-1.714Zm3.429,7.143h1.714v-1.714h-1.714Zm0-3.714h1.714v-1.714h-1.714Zm0-3.429h1.714v-1.714h-1.714Zm4,10.857h1.714v-1.714h-1.714Zm0-3.714h1.714v-1.714h-1.714Z",
    transform: "translate(1291 -223)",
    fill: "#758091"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.01eb8c8c56ea66d7c7320b21822acdb6.svg";
export { ForwardRef as ReactComponent };